<template>
  <div>
    <label>{{ label }}</label>
    <div class="qr_style_box">
      <div class="btn_choose_qr_style" @click="open_type = !open_type">
        {{ open_type ? 'Close QR style' : 'Choose QR style' }}
      </div>
      <div
        class="preview_qr_list_contaider"
        v-if="open_type"
        ref="preview_qr_list_contaider"
      >
        <div
          @click="handlePrev"
          class="preview-qr-list__btn preview-qr-list_btn_prev"
          ref="btnLeft"
        >
          <v-icon style="width: 20px" name="arrow-left"></v-icon>
        </div>
        <div class="preview-qr-list" ref="previewQrList">
          <PreviewQrType
            v-for="item in QRListStyle"
            :key="item.id"
            :config="item"
            :configId="configId"
            :chooseType="chooseType"
          />
        </div>
        <div
          @click="handleNext"
          class="preview-qr-list__btn preview-qr-list_btn_next"
          ref="btnRight"
        >
          <v-icon style="width: 20px" name="arrow-right"></v-icon>
        </div>
      </div>

      <label v-if="open_type">Data: </label>
      <textarea
        required
        class="form-control"
        v-model="dataText"
        rows="2"
      ></textarea>
    </div>

    <div v-if="message_error" class="message_error">{{ message_error }}</div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { get } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import PreviewQrType from '../Render/PreviewQrType.vue'
export default {
  name: 'ImageQR',
  components: {
    PreviewQrType
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    layer: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      dataText: '',
      debouceGenQr: null,
      message_error: '',
      configId: null,
      open_type: false
    }
  },
  computed: {
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    },
    layerid() {
      return get(this.layer, 'id', uuidv4())
    },
    defaultConfigId() {
      return get(this.layer, 'defaultConfigId')
    },
    QRListStyle() {
      return get(this.layer, 'QRListStyle')
    },
    isDisabledButton() {
      const { imageInput, nameInput, typeInput, genderInput, loading } = this
      if (!imageInput || !nameInput || !typeInput || loading || !genderInput) {
        return true
      }
    },
    localStorageName() {
      return this.context.name + '_' + this.product().id
    },
    modalName() {
      return `qr-${this.uniqueID(10)}`
    }
  },
  watch: {
    dataText() {
      this.debouceGenQr()
    },
    context(v) {
      const { text, configId } = v.model
      if (text) {
        this.dataText = text
      }
      if (configId) {
        this.configId = configId
      }
    },
    open_type(v) {
      if (v) {
        setTimeout(() => {
          this.checkOverflow()
        }, 200)
        window.addEventListener('resize', this.checkOverflow)
      } else {
        window.removeEventListener('resize', this.checkOverflow)
      }
    }
  },
  created() {
    this.debouceGenQr = debounce(this.genQR, 500)
    this.configId = this.defaultConfigId
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    ...mapGetters(['product', 'getCartData', 'isSaveLocalstorage']),
    ...mapMutations(['setCartDataByKey', 'setIsSaveLocalstorage']),
    checkOverflow() {
      const preview_qr_list_contaider = this.$refs.preview_qr_list_contaider
      const list = this.$refs.previewQrList
      const leftBtn = this.$refs.btnLeft
      const rightBtn = this.$refs.btnRight

      if (!list || !leftBtn || !rightBtn) return
      const isOverflow =
        list.scrollWidth > preview_qr_list_contaider.clientWidth

      // Hiển thị hoặc ẩn nút
      leftBtn.style.display = isOverflow ? 'flex' : 'none'
      rightBtn.style.display = isOverflow ? 'flex' : 'none'
    },
    handleNext() {
      this.$refs.previewQrList.scrollLeft += 200
    },
    handlePrev() {
      this.$refs.previewQrList.scrollLeft -= 200
    },
    chooseType(id) {
      this.configId = id
      this.genQR()
    },
    pushMessageError(message) {
      const THIS = this
      THIS.message_error = message
    },
    getNestedValue(obj, path) {
      return path.reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        obj
      )
    },

    normalizeColorStops(config) {
      const GRADIENT_PATHS = [
        ['dotsOptions', 'gradient'],
        ['cornersSquareOptions', 'gradient'],
        ['cornersDotOptions', 'gradient'],
        ['backgroundOptions', 'gradient']
      ]

      for (const path of GRADIENT_PATHS) {
        const gradient = this.getNestedValue(config, path)

        if (
          gradient &&
          gradient.colorStops &&
          !Array.isArray(gradient.colorStops)
        ) {
          gradient.colorStops = Object.keys(gradient.colorStops)
            .sort((a, b) => Number(a) - Number(b))
            .map(key => gradient.colorStops[key])
        }
      }
      return config
    },
    genQR() {
      const THIS = this
      const { configId, dataText, QRListStyle } = this
      const configsQR = QRListStyle.find(i => i.id == configId)
      if (!(configsQR && dataText)) return

      const radio = 1000 / (Number(configsQR.width) || 4000)
      const configs = this.normalizeColorStops({
        ...configsQR,
        width: Number(configsQR.width) * radio,
        height: Number(configsQR.height) * radio,
        margin: Number(configsQR.margin) * radio,
        data: dataText
      })

      try {
        const qrCode = new window.QRCodeStyling(configs)
        if (configs.shape && configs.shape == 'circle') {
          qrCode.applyExtension(
            window.QRBorderPlugin({
              ...configs.borderRadius,
              thickness: (configs.borderRadius.thickness || 0) * radio,
              dasharray: (configs.borderRadius.dasharray || 0) * radio
            })
          )
        }
        qrCode.getRawData('png').then(blob => {
          const reader = new FileReader()
          reader.onloadend = async () => {
            const base64data = reader.result
            THIS.setIsSaveLocalstorage(true)
            THIS.message_error = ''
            const file = {
              base64: base64data,
              text: dataText,
              configId
            }
            this.context.model = file
          }
          reader.readAsDataURL(blob)
        })
      } catch (error) {
        this.pushMessageError(error)
      }
    }
  }
}
</script>

<style scoped>
.message_error {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}
.preview-qr-list {
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  scroll-behavior: smooth;
  scroll-snap-align: center;
  scroll-snap-type: x mandatory;
  justify-content: flex-start;
  margin-bottom: 5px;
  margin: 0px 0px;
  width: 100%;
}

.preview-qr-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.preview-qr-list::-webkit-scrollbar {
  width: 0px;
  height: 0;
  background-color: #f5f5f5;
}

.preview-qr-list::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

.preview-qr-list > div {
  scroll-snap-align: center;
}
.preview_qr_list_contaider {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.preview-qr-list__btn {
  position: relative;
  background: #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  cursor: pointer;
  box-shadow: 0px 0px 10px -1px #3333335e;
}

.preview-qr-list_btn_prev {
  left: 0px;
  margin-right: 5px;
}
.preview-qr-list_btn_next {
  right: 0px;
  margin-left: 5px;
}

.btn_choose_qr_style {
  color: #0d6efd;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-align: end;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageQR.vue